import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Container, Row, Col, Card, Form, Button} from 'react-bootstrap';
import { useNavigate, Link, useParams } from 'react-router-dom';
//components
import {HappContainer} from 'happ-components/HappStyledComponents/HappContainer/HappContainer';
import {FormError} from 'happ-components/HappStyledComponents/HappFormStyles/HappFormStyles';
import logo from 'assets/imgs/imag_.png';
import LoginLoader from 'happ-components/Loader/LoginLoader';
//custom-hooks
import useValidatorFrom from 'happ-custom-hooks/useValidatorForm/useValidatorForms';
//actions
import {authProcessAction} from 'happ-redux/happ-actions/auth/authActions';
import TermsAndConditionsModalText from './TermsAndConditionsModalText';

const initState = {
    dni: '',
    password: '',
    terms: false
}
const Login = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const {
        state,
        errors,
        handlerSubmit,
        handlerChange,
        handlerChangeDni
    } = useValidatorFrom(initState, authProcess);
    const {dni, password, terms} = state;
    const {errorServer, errorMsg, session} = useSelector(state => state.auth);
    function authProcess(){
        const userParams = {
            rut:dni,
            password,
            terms
        }
        dispatch(authProcessAction(userParams, navigate));
    }    
    return ( 
        <Container>
            <LoginLoader show={session}/> 
                <Row className="vh-100 d-flex justify-content-center align-items-center">
                    <Col md={8} lg={6} xs={12}>
                        <HappContainer>
                            <Card className="shadow-box border-box">
                                <Card.Body className='card-login'>
                                    <div className="mb-3 mt-md-4">
                                        <div className="content-logo logo-login mt-3">
                                            <img src={logo} alt="description"/>
                                        </div>
                                    </div>
                                        <Form 
                                            className="form-action"
                                            onSubmit={handlerSubmit}
                                        >
                                            <Form.Group className="mb-3" controlId="formBasicEmail">
                                                <Form.Label className="text-center">
                                                    Rut
                                                </Form.Label>
                                                <Form.Control 
                                                    type="text" 
                                                    onChange={handlerChangeDni}
                                                    value={dni}
                                                    placeholder="11111111-1" 
                                                    name="dni" 
                                                />
                                                {errors.dni ? (
                                                    <FormError>{errors.dni}</FormError>
                                                ) : null}
                                                {errorServer && errorMsg.dni ? (
                                                    <FormError>{errorMsg.dni}</FormError>
                                                ) : null}
                                            </Form.Group>

                                            <Form.Group
                                                className="mb-3"
                                                controlId="formBasicPassword"
                                            >
                                                <Form.Label>
                                                    Contraseña
                                                </Form.Label>
                                                <Form.Control 
                                                    type="password" 
                                                    onChange={handlerChange}
                                                    value={password}
                                                    placeholder="******" 
                                                    name="password"
                                                />
                                                {errors.password ? (
                                                    <FormError>{errors.password}</FormError>
                                                ) : null}
                                                {errorServer && errorMsg.password ? (
                                                    <FormError>{errorMsg.password}</FormError>
                                                ) : null}
                                            </Form.Group>

                                            {errorServer && errorMsg.termsAndConditionsCheck === false ? (
                                                <Form.Group controlId="formBasicTerms">
                                                    <p className="inlineCheckbox">
                                                        <Form.Check 
                                                            type="checkbox"
                                                            onChange= {handlerChange}
                                                            name="terms"
                                                            value={terms}
                                                        />
                                                        <label className="inlineCheckboxLabel">
                                                            Debe aceptar los <TermsAndConditionsModalText/> para poder ingresar
                                                        </label>
                                                    </p>
                                                </Form.Group>
                                            ) : null}
                                            
                                            <Form.Group
                                                className="mb-3"
                                                controlId="formBasicCheckbox"
                                            >
                                                <div className="text-center">
                                                    <Link className="primary-color" to="/forgot-password">Obtén tu contraseña</Link>
                                                </div>
                                            </Form.Group>
                                            <div className="d-grid">
                                                <Button 
                                                    className="primary-bg-color" 
                                                    type="submit"
                                                >
                                                    Continuar
                                                </Button>
                                            </div>
                                        </Form>    
                                </Card.Body>
                            </Card>
                        </HappContainer>
                    </Col>
                </Row>
            </Container>
    );
}
 
export default Login;